import { Locale, type LocalizedString } from "../Locale.js";
import type { Tenant } from "../Tenant.js";
import { getPathInLocale } from "./getPathInLocale.js";

const pathMap = {
	[Locale.cs]: "/clo" as const,
	[Locale.en]: "/tariffs" as const,
} satisfies LocalizedString;

export function getTariffsPath(tenant: Tenant): string {
	return getPathInLocale(tenant.locale, pathMap);
}
